import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Fragment } from "react";
import { villaConfigurations } from "./villa-config-data";

function SleepingArrangement({ villa, desktop = false }: {
  villa: (typeof villaConfigurations)[number];
  desktop?: boolean;
}) {
  return villa.sleeping.map((line, index) => (
    <Fragment key={index}>
      {index > 0 && (desktop ? <br /> : " ")}
      {line.text}
      {line.note && <>{line.text && " "}<em>{line.note}</em></>}
      {line.suffix}
    </Fragment>
  ));
}

interface VillaConfigModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function VillaConfigModal({ isOpen, onClose }: VillaConfigModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-5xl max-h-[90vh] flex flex-col w-[95vw] sm:w-full border-border">
        <DialogHeader className="pb-4">
          <DialogTitle className="text-center text-2xl sm:text-[40px] font-light" style={{ fontFamily: 'Lato' }}>
            VILLA CONFIGURATIONS
          </DialogTitle>
        </DialogHeader>
        
        <ScrollArea className="px-3 sm:px-6 pb-6 flex-1 overflow-y-auto">
          <div className="space-y-6">
            {/* Villa Configuration Table - Desktop */}
            <div className="bg-background border border-border rounded-lg p-3 sm:p-6 hidden md:block">
              <div className="overflow-x-auto">
                <table className="w-full border-collapse rounded-lg overflow-hidden border border-border">
                  <thead>
                    <tr className="bg-[#b67244] text-white border-b border-border">
                      <th className="text-left py-4 px-6 font-semibold text-lg border-r border-border">
                        Accommodation Name
                      </th>
                      <th className="text-left py-4 px-6 font-semibold text-lg border-r border-border">
                        Sleeping Arrangement
                      </th>
                      <th className="text-left py-4 px-6 font-semibold text-lg">
                        Guests
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {villaConfigurations.map((villa, index) => (
                    <tr key={villa.name} className={`${index % 2 === 0 ? "bg-[#b67244]" : "bg-[#bd7e54]"} text-white${index < villaConfigurations.length - 1 ? " border-b border-border" : ""}`}>
                      <td className="py-4 px-6 font-medium border-r border-border">
                        {villa.emphasizeDesktopName ? <em>{villa.name}</em> : villa.name}
                      </td>
                      <td className="py-4 px-6 border-r border-border">
                        <SleepingArrangement villa={villa} desktop />
                      </td>
                      <td className="py-4 px-6 font-semibold text-center">
                        {villa.guests}
                      </td>
                    </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Villa Configuration Cards - Mobile */}
            <div className="md:hidden space-y-4">
              {villaConfigurations.map((villa) => (
                <div key={villa.name} className="bg-[#b67244] text-white rounded-lg p-4 border border-border">
                  <div className="space-y-3">
                    <div>
                      <h3 className="font-semibold text-lg mb-3">{villa.name}</h3>
                    </div>
                    <div>
                      <h4 className="font-semibold text-base mb-1">Sleeping Arrangement</h4>
                      <p className="text-sm"><SleepingArrangement villa={villa} /></p>
                    </div>
                    <div>
                      <h4 className="font-semibold text-base mb-1">Guests</h4>
                      <p className="text-lg font-bold text-left">{villa.guests}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Contact Information */}
            <div className="bg-muted border border-border rounded-lg p-4 sm:p-6">
              <h3 className="text-xl font-semibold mb-4 text-foreground">Need Help Planning Your Stay?</h3>
              <div>
                <p className="text-foreground mb-4 text-sm">
                  If you have questions about villa configurations or need assistance with your booking, please contact us:
                </p>
                <div className="bg-background p-4 rounded-lg border border-border">
                  <p className="text-foreground text-sm">
                    <strong>Email:</strong> info@tokaridge.co.nz<br />
                    <strong>Phone:</strong> +64 7 346 0090<br />
                    <strong>Address:</strong> 512A Hamurana Road, Rotorua, New Zealand
                  </p>
                </div>
              </div>
            </div>


          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
}